import { DEFAULT_SUBSCRIPTION } from '../constants'

export const initialSubscriptionState = {
  subscription: { ...DEFAULT_SUBSCRIPTION },
}
